<div *ngIf="user && formGroup" class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-white tw-border tw-border-[#E8E8E8] tw-rounded-[10px] md:tw-px-4 lg:tw-px-8">
  <form class="tw-w-full tw-h-fit tw-py-8 tw-px-4" [formGroup]="formGroup">
    <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-4 tw-mb-8">
      <p class="tw-flex-1 tw-font-poppins tw-font-bold tw-text-lg tw-text-secondary">
        {{ title | translate }}
      </p>
      <div (click)="closeModal()" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full tw-cursor-pointer">
        <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-light-icon.svg" />
      </div>
    </div>
    <app-input [formGroup]="formGroup" formControlName="name" [label]="'name' | translate"></app-input>

    <div class="full-dropdown tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "branch" | translate }}</p>
      <p-dropdown
        class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
        [options]="branches"
        [(ngModel)]="selectedBranch"
        [ngModelOptions]="{ standalone: true }"
        dataKey="id"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [placeholder]="'branch' | translate"
        (onFilter)="searchBranches.next($event.filter)"
        [emptyFilterMessage]="searchBranchesNoResults | translate"
        (onChange)="setBranch($event)"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ item.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
      <p *ngIf="formGroup.get('branch_id').touched && formGroup.get('branch_id').invalid" class="tw-font-poppins tw-text-xs tw-text-danger tw-mt-1">
        {{ "branch-is-required" | translate }}
      </p>
    </div>

    <div *ngIf="tableUrl" class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-items-center tw-gap-3 tw-mb-6">
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary">{{ "table-qr-code" | translate }}</p>
      <qrcode [qrdata]="tableUrl" [width]="200" [errorCorrectionLevel]="'M'" [elementType]="'canvas'" (qrCodeURL)="onQrCodeUrlChange($event)"></qrcode>
      <p class="tw-w-full tw-font-poppins tw-text-xs tw-text-secondary tw-text-center tw-break-all">{{ tableUrl }}</p>
      <p *ngIf="qrCodeRegenerated" class="tw-w-full tw-font-poppins tw-text-xs tw-text-danger tw-text-center">
        {{ "qr-code-regenerated-warning" | translate }}
      </p>
      <div
        *ngIf="table"
        (click)="regenerateQrCode()"
        class="tw-w-full tw-text-center tw-font-poppins tw-font-semibold tw-text-sm tw-text-danger tw-border tw-border-danger tw-rounded-[5px] tw-px-3 tw-py-2 tw-cursor-pointer"
      >
        {{ "regenerate-qr-code" | translate }}
      </div>
      <div class="tw-w-full tw-flex tw-gap-2">
        <a
          [href]="qrCodeDownloadLink"
          [download]="(formGroup.get('name').value || 'table') + '-qr-code.png'"
          class="tw-flex-1 tw-text-center tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary tw-border tw-border-secondary tw-rounded-[5px] tw-px-3 tw-py-2 tw-cursor-pointer"
        >
          {{ "download-qr-code" | translate }}
        </a>
        <div (click)="copyTableUrl()" class="tw-flex-1 tw-text-center tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary tw-border tw-border-secondary tw-rounded-[5px] tw-px-3 tw-py-2 tw-cursor-pointer">
          {{ "copy-link" | translate }}
        </div>
      </div>
    </div>

    <div class="tw-w-full tw-h-2"></div>
    <app-button [disabled]="disableButton" [text]="'save' | translate" [fullWidth]="true" [onButtonClick]="buttonClicked.bind(this)"></app-button>
  </form>
</div>
